import React from 'react';
import { BorderColor } from '@mui/icons-material';
import {
  ApplicationViewList,
  type ApplicationViewListProps,
  type ApplicationViewTableDataItem,
  type CustomAction,
  type FilterFields,
  type TableColumns,
} from '../../../../../Application/components';

type ConditionCheckListProps = {
  filter: any;
};

export const ConditionCheckList: React.FC<ConditionCheckListProps> = (
  props: ConditionCheckListProps,
) => {
  const { filter: listFilter } = props;

  const visibleColumns: TableColumns[] = React.useMemo(
    () => [
      'applicationNo',
      'applicantName',
      'applicantEmail',
      'entryYear',
      'programmeCode',
      'applyProgramme',
      'researchAreas',
      'applicationStatus',
      'meetConditionCheckStatus',
      'meetConditionCheckDeadline',
      'meetConditionCheckUpdatedAt',
    ],
    [],
  );

  const hiddenFilters: FilterFields[] = React.useMemo(
    () => [
      'department',
      'applicantIdentityType',
      'applicantLocalIndicator',
      'scholarshipAppliedByApplicant',
      'applicationStatus',
      'fundingSchemeStatus',
      'fundingScheme',
      'dualPartnerUniversity',
      'jointpartnerUniversity',
      'partnerCategory',
      'gsAssignee',
    ],
    [],
  );

  const handleSwitchConditionCheck = (
    row: ApplicationViewTableDataItem,
  ): void => {
    window.open(
      `/internal/dorpgs-homepage/dorpgsassessment/condition-check/${row.applicationId}`,
    );
  };
  const customActions: CustomAction[] = [
    {
      icon: <BorderColor />,
      handleAction: handleSwitchConditionCheck,
      checkDisable: () => false,
    },
  ];

  const filterProps: ApplicationViewListProps['filterProps'] = {
    hiddenFilterFields: hiddenFilters,
  };

  const toolsProps: ApplicationViewListProps['toolsProps'] = {
    enableExport: false,
  };
  const tableProps: ApplicationViewListProps['tableProps'] = {
    initialVisibleColumns: visibleColumns,
    listFilter,
    customActions,
    minWidth: '1400px',
  };

  return (
    <div className="min-w-[1400px] overflow-x-auto">
      <ApplicationViewList
        tableProps={tableProps}
        filterProps={filterProps}
        toolsProps={toolsProps}
      />
    </div>
  );
};
